import { ShippingConditionsRequest } from '@cemex-core/cmx-api/models/shipping-conditions/shipping-conditions-request';
import { createAction, props } from '@ngrx/store';
import { CxShippingCondition } from '../../models/shipping-condition';

export interface CxShippingConditionsRequest extends Omit<ShippingConditionsRequest, 'productTypeIds'> {
  productTypeIds: string | number;
}

export const resetState = createAction('[SHIPPING_CONDITION] Reset State');
export const initEntity = createAction('[SHIPPING_CONDITION] Init Entity', props<{ id: string }>());
export const resetEntityState = createAction('[SHIPPING_CONDITION] Reset Entity', props<{ id: string }>());
export const fetchEntity = createAction(
  '[SHIPPING_CONDITION] Fetch Entity start',
  props<CxShippingConditionsRequest>(),
);
export const updateEntity = createAction(
  '[SHIPPING_CONDITION] Update Entity',
  props<{ payload: CxShippingCondition }>(),
);
export const updateEntities = createAction(
  '[SHIPPING_CONDITION] Update Entities',
  props<{ payload: CxShippingCondition[] }>(),
);
export const selectEntity = createAction('[SHIPPING_CONDITION] Select Entity', props<{ id: string }>());

export const CxShippingConditionActions = {
  resetState,
  initEntity,
  resetEntityState,

  updateEntity,
  updateEntities,
  selectEntity,

  fetchEntity,
};

export default CxShippingConditionActions;
